(function () {
	const productSlider = () => {
		function toBoolean(string) {
			return string === "true" ? true : false;
		}

		const sections = document.querySelectorAll(".popular-products");

		sections.forEach(function (section) {
			const wrapper = section.querySelector(".popular-products-slider");
			const swiperSlide = section.querySelectorAll(".swiper-slide");
			
			if (!wrapper) return;

			const sectionId = wrapper.dataset.id;
			const speed = wrapper.dataset.speed * 1000;
			const delay = wrapper.dataset.delay * 1000;
			const autoplay = toBoolean(wrapper.dataset.autoplay);
			const stopAutoplay = toBoolean(wrapper.dataset.stopAutoplay);
			
			let autoplayParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}

			const swiperParms = {
				speed: speed,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				// Enable touch/swipe
				touchEventsTarget: 'container',
				simulateTouch: true,
				allowTouchMove: true,
				touchRatio: 1,
				touchAngle: 45,
				grabCursor: true,
				// Responsive slides
				slidesPerView: 1.2,
				spaceBetween: 0,
				centeredSlides: false,
				// Navigation
				navigation: {
					nextEl: `#${sectionId} .swiper-button-next`,
					prevEl: `#${sectionId} .swiper-button-prev`,
				},
				// SUPPRIMÉ - Pagination progressbar
				// pagination: {
				// 	el: `#${sectionId} .swiper-pagination`,
				// 	type: "progressbar",
				// },
				// Breakpoints pour responsive
				breakpoints: {
					576: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					990: {
						slidesPerView: 3,
						spaceBetween: 0,
					},
					1100: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
				},
				...autoplayParm,
			};

			// Initialize Swiper
			const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		document.addEventListener("shopify:section:load", function () {
			productSlider();
		});
	});
})();
